export function getCalcTypes(): { [key: string]: string } {
  return {
    hacoplay: "ハコプレ",
    paperBug: "紙袋"
  };
}
